import React, { Component } from 'react'
import ChainCircle, { RightArrow, RefreshLogo, TwitterIcon, YoutubeIcon, ArrowFly } from '../Svg/index';
import styles from './stylesheets/SocialIconsFooter.module.css';

export class SocialIconsInFooter extends Component {
    render() {
        return (

            <div className={styles.socialIconsInFooter}>
                <div className={styles.socialIconsCont}>
                    <a href="">
                        <div className={styles.icon}>
                            <TwitterIcon></TwitterIcon>
                        </div>
                        <div className={styles.socialIconText}>
                            Twitter
                        </div>
                    </a>
                    <a href="">
                        <div className={styles.icon}>
                            <ArrowFly></ArrowFly>
                        </div>
                        <div className={styles.socialIconText}>
                            TELEGRAM GROUP
                        </div>
                    </a>
                    <a href="">
                        <div className={styles.icon}>
                            <ArrowFly></ArrowFly>
                        </div>
                        <div className={styles.socialIconText}>
                            ANNOUNCEMENTS
                        </div>
                    </a>
                    <a href="">
                        <div className={styles.icon}>
                            <YoutubeIcon></YoutubeIcon>
                        </div>
                        <div className={styles.socialIconText}>
                            Youtube
                        </div>
                    </a>

                    <div className={styles.zuzCompany}>
                        <p>(C) ZUZ FINANCE 2021</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default SocialIconsInFooter
